import {Route, BrowserRouter as Router, Routes} from 'react-router-dom';
import './assets/css/style.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Login from './pages/Login';
import VerificationCodeSend from './pages/VerificationCodeSend';
import VerificationCodeAdd from './pages/VerificationCodeAdd';
import MultifactorAuthentication from './pages/MultifactorAuthentication';
import SelectClient from './pages/SelectClient';
import Dashboard from './pages/Dashboard';
import Documents from "./pages/Documents";
import Certifications from "./pages/Certifications";
import AddDocument from "./pages/AddDocument";
import EditDocument from "./pages/EditDocument";
import AddCertificate from "./pages/AddCertificate";
import EditCertificate from "./pages/EditCertificate";
import CalendarView from "./pages/CalendarView";
import CreateSchoolYear from "./pages/CreateSchoolYear";
import EditSchoolYear from "./pages/EditSchoolYear";
import LettersNotices from "./pages/LettersNotices";
import CreateNewTemplate from "./pages/CreateNewTemplate";
import ErrorPage from "./pages/ErrorPage";
import LandingPage from "./pages/LandingPage";
import EditTemplate from "./pages/EditTemplate";
import SendLetters from "./pages/SendLetters";
import LettersPreview from "./pages/LettersPreview";
import LettersAcknowledgement from "./pages/LettersAcknowledgement";
import Processes from "./pages/Processes";
import CreateProcessTemplate from "./pages/CreateProcessTemplate";
import EditProcessTemplate from "./pages/EditProcessTemplate";
import SendProcess from "./pages/SendProcess";
import ManageProcess from "./pages/ManageProcess";
import {PrivateRoute} from './components/PrivateRoute';
import {SuperAdminRoute} from './components/SuperAdminRoute';
import SuperAdminManagement from "./pages/SuperAdmin/SuperAdminManagement";
import AddSuperAdmin from "./pages/SuperAdmin/AddSuperAdmin";
import EditSuperAdmin from "./pages/SuperAdmin/EditSuperAdmin";
import ClientManagement from "./pages/SuperAdmin/ClientManagement";
import AddClient from "./pages/SuperAdmin/AddClient";
import TeacherList from "./pages/SuperAdmin/TeachersList";
import EditClient from "./pages/SuperAdmin/EditClient";
import EditTeacherAssociate from "./pages/SuperAdmin/EditTeacherAssociate";
import AddTrustedAdvisor from "./pages/SuperAdmin/AddTrustedAdvisor";
import EditTrustedAdvisor from "./pages/SuperAdmin/EditTrustedAdvisor";
import ResponsePage from "./pages/ResponsePage";
import {jwtDecode} from "jwt-decode";
import {ClientRoute} from "./components/ClientRoute";
import Analytics from "./pages/SuperAdmin/Analytics";
import {ACCESS_TOKEN} from "./constants";

function App() {

    const checkRoleAccessLevels = () => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        return token && jwtDecode(token).RoleAccessLevels != 0;
    };

    const checkIsDocumentsEnables = () => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        return token && jwtDecode(token).IsDocumentsEnable != "False";
    };

    const checkIsLettersEnable = () => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        return token && jwtDecode(token).IsLettersEnable != "False";
    };

    const checkIsProcessesEnable = () => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        return token && jwtDecode(token).IsProcessesEnable != "False";
    };

    return (
        <Router>
            <Routes>
                <Route path="/sign-in" element={<Login/>}/>
                <Route path="/verification-code" element={<VerificationCodeSend/>}/>
                <Route path="/verification-code-add" element={<VerificationCodeAdd/>}/>
                <Route path="/mfa" element={<MultifactorAuthentication/>}/>
                <Route path="/client" element={<SelectClient/>}/>
                <Route path="/service-response" element={<ResponsePage/>}/>

                <Route path='*' element={<ErrorPage/>}/>
                <Route element={<PrivateRoute/>}>
                    <Route element={<ClientRoute/>}>
                        <Route path="/dashboard" element={<Dashboard/>}/>
                        <Route path="/landing-page/:id" element={<LandingPage/>}/>
                        <Route path="/" element={<Dashboard/>}/>
                        {<Route path="/documents" element={<Documents/>}/>}
                        {<Route path="/add-documents" element={<AddDocument/>}/>}
                        {checkIsDocumentsEnables() && checkRoleAccessLevels() &&
                            <Route path="/edit-documents/:id" element={<EditDocument/>}/>}
                        <Route path="/certifications" element={<Certifications/>}/>
                        <Route path="/add-certificate" element={<AddCertificate/>}/>
                        {checkRoleAccessLevels() &&
                            <Route path="/edit-certificate/:id" element={<EditCertificate/>}/>}

                        <Route path="/calendar" element={<CalendarView/>}/>
                        {checkRoleAccessLevels() &&
                            <Route path="/create-school-year" element={<CreateSchoolYear/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/edit-school-year/:id" element={<EditSchoolYear/>}/>}

                        {checkIsLettersEnable() && checkRoleAccessLevels() &&
                            <Route path="/letters-notices" element={<LettersNotices/>}/>}
                        {checkIsLettersEnable() && checkRoleAccessLevels() &&
                            <Route path="/create-new-template" element={<CreateNewTemplate/>}/>}
                        {checkIsLettersEnable() && checkRoleAccessLevels() &&
                            <Route path="/edit-template/:id" element={<EditTemplate/>}/>}
                        {checkIsLettersEnable() && checkRoleAccessLevels() &&
                            <Route path="/send-letters-notices" element={<SendLetters/>}/>}
                        {checkIsLettersEnable() && checkRoleAccessLevels() &&
                            <Route path="/letters-preview" element={<LettersPreview/>}/>}
                        {checkIsLettersEnable() && checkRoleAccessLevels() &&
                            <Route path="/letters-acknowledgement" element={<LettersAcknowledgement/>}/>}

                        {checkIsProcessesEnable() && checkRoleAccessLevels() &&
                            <Route path="/processes" element={<Processes/>}/>}
                        {checkIsProcessesEnable() && checkRoleAccessLevels() &&
                            <Route path="/create-process-template" element={<CreateProcessTemplate/>}/>}
                        {checkIsProcessesEnable() && checkRoleAccessLevels() &&
                            <Route path="/edit-process-template/:id" element={<EditProcessTemplate/>}/>}
                        {checkIsProcessesEnable() && checkRoleAccessLevels() &&
                            <Route path="/send-process" element={<SendProcess/>}/>}
                        {checkIsProcessesEnable() && checkRoleAccessLevels() &&
                            <Route path="/manage-process/:id/:type" element={<ManageProcess/>}/>}
                    </Route>
                    <Route element={<SuperAdminRoute/>}>
                        <Route path="/super-admin-management" element={<SuperAdminManagement/>}/>
                        <Route path="/super-admin-add" element={<AddSuperAdmin/>}/>
                        <Route path="/super-admin-edit/:id" element={<EditSuperAdmin/>}/>

                        <Route path="/client-management" element={<ClientManagement/>}/>
                        <Route path="/client-add" element={<AddClient/>}/>
                        <Route path="/client-edit/:id" element={<EditClient/>}/>
                        <Route path="/client-teacher-list/:id" element={<TeacherList/>}/>
                        <Route path="/client-user-edit/:id/:client" element={<EditTeacherAssociate/>}/>

                        {checkRoleAccessLevels() &&
                            <Route path="/letters-notices" element={<LettersNotices/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/create-new-template" element={<CreateNewTemplate/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/edit-template/:id" element={<EditTemplate/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/send-letters-notices" element={<SendLetters/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/letters-preview" element={<LettersPreview/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/letters-acknowledgement" element={<LettersAcknowledgement/>}/>}

                        {checkRoleAccessLevels() &&
                            <Route path="/processes" element={<Processes/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/create-process-template" element={<CreateProcessTemplate/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/edit-process-template/:id" element={<EditProcessTemplate/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/send-process" element={<SendProcess/>}/>}
                        {checkRoleAccessLevels() &&
                            <Route path="/manage-process/:id/:type" element={<ManageProcess/>}/>}

                        <Route path="/trusted-advisor-add" element={<AddTrustedAdvisor/>}/>
                        <Route path="/trusted-advisor-edit/:advisor" element={<EditTrustedAdvisor/>}/>

                        <Route path="/analytics" element={<Analytics/>}/>

                    </Route>
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
